var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34 9.333a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm4.653 0a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm6-1.333a1.333 1.333 0 11-2.666 0 1.333 1.333 0 012.666 0z",
    fill: "#121314"
  })));
}
export default SvgMedium;